// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AdminAccessTimeRequest } from './admin-access-time-request';

/** See com.rev360.pms.api.controller.admin.employee.detailed.request.AdminEmployeeLoginRestrictionRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminEmployeeLoginRestrictionRequest extends GandalfModelBase {

	@GandalfProperty({ designType: AdminAccessTimeRequest })
	friday!: AdminAccessTimeRequest | null;

	@GandalfProperty({ designType: AdminAccessTimeRequest })
	monday!: AdminAccessTimeRequest | null;

	@GandalfProperty({ designType: AdminAccessTimeRequest })
	saturday!: AdminAccessTimeRequest | null;

	@GandalfProperty({ designType: AdminAccessTimeRequest })
	sunday!: AdminAccessTimeRequest | null;

	@GandalfProperty({ designType: AdminAccessTimeRequest })
	thursday!: AdminAccessTimeRequest | null;

	@GandalfProperty({ designType: AdminAccessTimeRequest })
	tuesday!: AdminAccessTimeRequest | null;

	@GandalfProperty({ designType: AdminAccessTimeRequest })
	wednesday!: AdminAccessTimeRequest | null;

}
